var _module_exports ="<div class=\"row nopadding\">\n\n    <!-- Sidebar -->\n    <div ui-view=\"sidebar\"></div>\n\n    <!-- Details -->\n    <div ui-view=\"details\"></div>\n</div>";;
var path = '/app/Main/admin/adminEmailTemplates/MainEmailTemplates.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;